import type { IVector3 } from '@seddi/math-v2';

export type CameraLookAt = {
  distance: number;
  origin: IVector3;
  target: IVector3;
};

export const create = (): CameraLookAt => {
  return {
    distance: 0,
    origin: { x: 0, y: 0, z: 0 },
    target: { x: 0, y: 0, z: 0 },
  };
};

export const clone = (other: CameraLookAt): CameraLookAt => {
  return {
    distance: other.distance,
    origin: { ...other.origin },
    target: { ...other.target },
  };
};

export const copy = (t: CameraLookAt, other: CameraLookAt) => {
  t.distance = other.distance;
  t.origin.x = other.origin.x;
  t.origin.y = other.origin.y;
  t.origin.z = other.origin.z;
  t.target.x = other.target.x;
  t.target.y = other.target.y;
  t.target.z = other.target.z;
};
